import { t } from "@/i18n-js/instance";
import { Dropdown } from "@circle-react-uikit/Dropdown";

interface RerunProps {
  showRerunConfirmation: () => void;
}

export const Rerun = ({ showRerunConfirmation }: RerunProps) => (
  <Dropdown.ItemWithLink onClick={showRerunConfirmation}>
    {t("settings.workflows.table.actions.rerun")}
  </Dropdown.ItemWithLink>
);
